/* =============================================================
   TOUR SPRAY — Sitewide shared JS
   - Runs on every page
   - Reveal on scroll (no GSAP required)
   - Smooth anchor scrolling
   - Accessible <details> transitions (no-op if not present)
   ============================================================= */
(function () {
  'use strict';

  function revealObserver(scope) {
    const els = (scope || document).querySelectorAll('.tsv2-reveal, .tsv2-reveal-stagger');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach((e) => e.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    els.forEach((e) => io.observe(e));
  }

  function init() {
    revealObserver();

    // Smooth anchor scroll (for in-page links)
    document.querySelectorAll('a[href^="#"]').forEach((a) => {
      const id = a.getAttribute('href');
      if (!id || id === '#') return;
      a.addEventListener('click', (e) => {
        const target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
